import React from "react";
import { App } from "./app";
import "./style.css";
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");
const root = createRoot(container);
const Wrapper =
    process.env.NODE_ENV === "development" ? React.Fragment : React.StrictMode;

root.render(
    <Wrapper>
        <App />
    </Wrapper>
);
